import { useUser } from '@clerk/clerk-react';
import { useParams } from 'react-router-dom';

/**
 * Returns the tenantCode from the current Clerk user's publicMetadata.
 * Superadmin users return null (they don't belong to a tenant).
 */
export const useTenantCode = (): string | null => {
    const { tenantCode: routeTenantCode } = useParams<{ tenantCode?: string }>();
    const { user } = useUser();

    return routeTenantCode || (user?.publicMetadata?.tenantCode as string) || null;
};
